import { render, staticRenderFns } from "./BohrHydrogenViz.vue?vue&type=template&id=e23e1782&scoped=true"
import script from "./BohrHydrogenViz.vue?vue&type=script&lang=js"
export * from "./BohrHydrogenViz.vue?vue&type=script&lang=js"
import style0 from "./BohrHydrogenViz.vue?vue&type=style&index=0&id=e23e1782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23e1782",
  null
  
)

export default component.exports